import CurrencyInput, { CurrencyInputProps } from "react-currency-input-field";
import inputStyles from "components/Common/Field/Input/Input.module.scss";
import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Field } from "components/Common/Field";
import { cn } from "utils/misc";
import { Input } from "components/Common/Field/Input";

type Props<TFieldValues extends FieldValues> = CurrencyInputProps & {
  name: Path<TFieldValues>;
  label: string;
};

export const FormPriceInput = <TFieldValues extends FieldValues>({ name, label, ...rest }: Props<TFieldValues>) => {
  const methods = useFormContext<TFieldValues>();

  if (!methods) {
    throw new Error("FormPriceInput must be used inside a <Form />");
  }

  const errorMessage = methods?.formState.errors[name]?.message;

  return (
    <Field error={(errorMessage as string) || ""} label={label} labelFor={name}>
      <Input hasError={!!errorMessage} adornmentLeft={{ label: "$", labelFor: name }}>
        <CurrencyInput
          id={name}
          allowNegativeValue={false}
          className={cn(inputStyles.input, inputStyles.input__native, inputStyles["input__native--text"])}
          min={0}
          placeholder=""
          maxLength={10}
          {...(methods?.register && methods.register(name))}
          {...rest}
        />
      </Input>
    </Field>
  );
};
